<template>
  <div
    class="feed-entry"
    :if="entry.localeId === 1"
  >
  <!-- <a :href="'https://nelsonirrigation.com/announcements/' + entry.url"> -->
    <span class="entry-type">{{ entry.type.toUpperCase() }}</span>
    <span class="entry-date headline5">{{ entry.publishDate }}</span>
    <span class="headline2">{{ entry.title }}</span>
    <p class="headline3">
      {{ entry.summary }}
    </p>
    <img
      :src="'https://ndb.nelsonirrigation.com/announcementsImg/ann-image_' + entry.announcementID + '-0.jpg'"
      style="width:80%;height:auto;margin-left:10%"
    >
    <!-- </a> -->
  </div>
</template>
<script>
export default {
    props: {
        entry: {
            type: Object,
            required: true
        }
    },

};
</script>
<style scoped>
.feed-entry {
    padding: 20px;
    width: 80%;
    cursor: pointer;
    border: 0px solid lightgray;
    margin-bottom: 2px;
    margin-left:7%;
    background-color: white;
}
.entry-date{
    display:block;
}
.entry-type{
    color:grey;
    font-weight:700;
    letter-spacing:0.9pt;
    font-size: 11px;
}
/* .feed-entry:hover {
   transform: scale(1.01);
    box-shadow: 0 3px 12px 0 rgba(0, 0, 0, 0.2);
} */
</style>